var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{staticClass:"status-toolbar",style:({ 
    borderColor: _vm.itemData.color 
  }),attrs:{"outlined":"","rounded":"","flat":""}},[_c('v-toolbar-title',{staticClass:"body-1 font-weight-medium",style:({
      color: _vm.itemData.color
    })},[_vm._v(" Status: "+_vm._s(_vm.itemData.text)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }